// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--mbOLt","BodyContainerText":"_BodyContainerText--gxi_N","WarningIcon":"_WarningIcon--GCI8v","Heading":"_Heading--hmJ9i"};